export const CONTEXT_CONSTANTS = {
  TOGGLE_MOBILE_SIDEBAR: "TOGGLE_MOBILE_SIDEBAR",
  TOGGLE_CASE_DETAIL_META_PANE: "TOGGLE_CASE_DETAIL_META_PANE",
  TOGGLE_ARTICLE_DETAIL_META_PANE: "TOGGLE_ARTICLE_DETAIL_META_PANE",

  // article/knowledgebase constants
  SET_SELECTED_ARTICLE: "SET_SELECTED_ARTICLE",
  SET_DETAILED_ARTICLE_INFORMATION: "SET_DETAILED_ARTICLE_INFORMATION",
  SET_HAS_UPDATED_ARTICLE_INFORMATION: "SET_HAS_UPDATED_ARTICLE_INFORMATION",

};

export const INQUIRY_CONTEXT_CONSTANTS = {
  SET_CURRENT_STEP: "SET_CURRENT_STEP",
  SET_ALL_STEPS: "SET_ALL_STEPS",
  SET_QUESTIONNAIRE: "SET_QUESTIONNAIRE",
  SET_STEP_FORM_VALUES: "SET_STEP_FORM_VALUES",
  SET_LEAD: "SET_LEAD",
  TOGGLE_CONFETTI: "TOGGLE_CONFETTI",
};
